import React, { useEffect } from 'react';
import { View } from "@/styles/reactnative";
import OrderPreferenceCheckBox from "./OrderPreferenceCheckBox";
import OrderPreferenceNote from "./OrderPreferenceNote";
import useTradeStore from "@app/hooks/trade/tradeStore.tsx";

const OrderModalBody = ({
  orderQty,
  setOrderQty,
  orderByValue,
  setOrderByValue,
  symbol,
}) => {
  const { data: tradeStore } = useTradeStore();
  const orderType = tradeStore?.main_sub || "M";


  return (
    <View
      style={{
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      <OrderPreferenceCheckBox
        checked={orderType === "M"}
        setOrderByValue={setOrderByValue}
        orderByValue={orderByValue}
        setOrderQty={setOrderQty}
        orderQty={orderQty}
        type={"qty"}
        title={"orderByQty"}
        content={"orderByQtyDesc"}
        coinType={symbol}
      />

      <OrderPreferenceCheckBox
        checked={orderType === "S"}
        setOrderByValue={setOrderByValue}
        orderByValue={orderByValue}
        setOrderQty={setOrderQty}
        orderQty={orderQty}
        type={"value"}
        title={"orderByValue"}
        content={"orderByValueDesc"}
        coinType={"USDT"}
      />
      {orderByValue ? <OrderPreferenceNote /> : null}
    </View>
  );
};

export default OrderModalBody;
